import { createRouter, createWebHistory } from 'vue-router'
import NotFound from "@/components/error/404.vue"
import AppLayout from "@/components/app-layout/AppLayout.vue";
import Home from "@/views/home/home.vue";
import About from "@/views/about/about.vue";
import ShcMachine from "@/views/shc-machine/shc-machine.vue";
import Contact from "@/views/contact/contact.vue";
import Blog from "@/views/blog/blog.vue"
import Intership from "@/views/blog/blog-content/intership-tip/index.vue"
import MarginSummer from "@/views/blog/blog-content/margin-summer-2025/margin-summer-2025.vue"
import NewAccountVantage from "@/views/blog/blog-content/new-account-vantage/new-account-vantage.vue";
import EaShc from "@/views/blog/blog-content/ea-shc/ea-shc.vue";
import ConectStudent from "@/views/blog/blog-content/conect-student/conect-student.vue";
import L251120 from "@/views/blog/blog-content/251120/251120.vue";
import Promo100k from "@/views/blog/blog-content/promo-100k/promo-100k.vue";
import Top8Vantage from "@/views/blog/blog-content/top8-vantage/top8-vantage.vue";
import PuPrimeVietnamReward from "@/views/blog/blog-content/pu-prime-vietnam-reward/pu-prime-vietnam-reward.vue";
import VantageBonus088 from "@/views/blog/blog-content/vantage-bonus-088/vantage-bonus-088.vue";
import ShcTechnicalAnalysis from "@/views/blog/blog-content/shc-technical-analysis/shc-technical-analysis.vue";
import MasterPartnerProgram from "@/views/blog/blog-content/master-partner-program/master-partner-program.vue";
import Strategies from "@/views/strategies/strategies.vue";
import Performance from "@/views/performance/performance.vue";
import Invest from "@/views/invest/invest.vue";
import Fund from "@/views/fund/fund.vue";
import {i18n} from "@/config/i18n.js";
const router = createRouter({
  history: createWebHistory("/"),
  scrollBehavior() {
    return { top: 0, behavior: 'smooth' };
  },
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: AppLayout,
      title: i18n.global.t("header.home"),
      meta: {
      },
      children: [
        {
          path: '',
          name: 'Home',
          component: Home,
          meta: {
            title: i18n.global.t("header.home"),
            error: false,
            isBlog: false,
            isNewWindow: false,
            isBanner: false
          },
        },
        {
          path: 'about',
          name: 'About',
          component: About,
          meta: {
            title: i18n.global.t("header.about"),
            error: false,
            isBlog: false,
            isNewWindow: false,
            isBanner: false
          },
        },
        {
          path: '/blog',
          name: 'News',
          component: Blog,
          meta: {
            title: i18n.global.t("header.blogPage"),
            error: false,
            isBlog: false,
            isNewWindow: false,
            isBanner: false
          },
        },
        {
          path: '/blog/dau-tu-an-toan-loi-nhuan-on-dinh-cung-ea-shc',
          name: 'EaShc',
          component: EaShc,
          meta: {
            title: i18n.global.t("blog.EaShc"),
            error: false,
            isBlog: true,
            isNewWindow: false,
            isBanner: true
          },
        },
        {
          path: '/blog/conect-student',
          name: 'ConectStudent',
          component: ConectStudent,
          meta: {
            title: i18n.global.t("blog.ConectStudent"),
            error: false,
            isBlog: true,
            isNewWindow: false,
            isBanner: true
          },
        },
        {
          path: '/blog/gioi-thieu-san-pham-margin-uu-dai-SH-6.8',
          name: 'MarginSummer2025',
          component: MarginSummer,
          meta: {
            title: i18n.global.t("blog.MarginSummer"),
            error: false,
            isBlog: true,
            isNewWindow: false,
            isBanner: true
          },
        },
        {
          path: '/blog/mo-tai-khoan-moi-tai-vantage-qua-shc',
          name: 'NewAccountVantage',
          component: NewAccountVantage,
          meta: {
            title: i18n.global.t("blog.NewAccountVantage"),
            error: false,
            isBlog: true,
            isNewWindow: false,
            isBanner: true
          },
        },
        {
          path: '/blog/tuyen-dung-thuc-tap-sinh',
          name: 'Intership',
          component: Intership,
          meta: {
            title: i18n.global.t("blog.Intership"),
            error: false,
            isBlog: true,
            isNewWindow: false,
            isBanner: false
          }
        },
        {
          path: '/blog/chuc-mung-ngay-nha-giao-Viet-Nam-20/11/2025',
          name: 'L251120',
          component: L251120,
          meta: {
            title: i18n.global.t("blog.blog6.title"),
            error: false,
            isBlog: true,
            isNewWindow: false,
            isBanner: false
          }
        },
        {
          path: '/blog/ket-noi-ngay-qua-lien-tay',
          name: 'Promo100k',
          component: Promo100k,
          meta: {
            title: i18n.global.t("blog.promo100k.heroTitle"),
            error: false,
            isBlog: true,
            isNewWindow: false,
            isBanner: true
          }
        },
        {
          path: '/blog/chuc-mung-shc-vao-top-8-vantage',
          name: 'Top8Vantage',
          component: Top8Vantage,
          meta: {
            title: i18n.global.t("blog.top8Vantage.cardTitle"),
            error: false,
            isBlog: true,
            isNewWindow: false,
            isBanner: true
          }
        },
        {
          path: '/blog/pu-prime-vietnam-premier-reward-2026',
          name: 'PuPrimeVietnamReward',
          component: PuPrimeVietnamReward,
          meta: {
            title: i18n.global.t("header.puPrimeReward"),
            error: false,
            isBlog: true,
            isNewWindow: false,
            isBanner: true
          }
        },
        {
          path: '/blog/vantage-bonus-088-daily-profit',
          name: 'VantageBonus088',
          component: VantageBonus088,
          meta: {
            title: i18n.global.t("header.vantageBonus"),
            error: false,
            isBlog: true,
            isNewWindow: false,
            isBanner: true
          }
        },
        {
          path: '/blog/chuong-trinh-phat-trien-master-partner',
          name: 'MasterPartnerProgram',
          component: MasterPartnerProgram,
          meta: {
            title: i18n.global.t("header.masterPartner"),
            error: false,
            isBlog: true,
            isNewWindow: false,
            isBanner: true
          }
        },
        {
          path: '/blog/ngoai-khoa-ung-dung-phan-tich-ky-thuat-shc',
          name: 'ShcTechnicalAnalysis',
          component: ShcTechnicalAnalysis,
          meta: {
            title: 'Ngoại khóa ứng dụng phân tích kỹ thuật - SHC Capital',
            error: false,
            isBlog: true,
            isNewWindow: false,
            isBanner: false
          }
        },
        {
          path: '/shc-machine',
          name: 'ShcSignal',
          component: ShcMachine,
          meta: {
            title: i18n.global.t("header.shcSignal"),
            error: false,
            isBlog: false,
            isHidden: true,
            isNewWindow: false,
            isBanner: false
          }
        },
        {
          path: '/strategies',
          name: 'Strategies',
          component: Strategies,
          meta: {
            title: i18n.global.t("header.strategies"),
            error: false,
            isBlog: false,
            isHidden: true,
            isNewWindow: false,
            isBanner: false
          }
        },
        {
          path: '/performance',
          name: 'Performance',
          component: Performance,
          meta: {
            title: i18n.global.t("header.performance"),
            error: false,
            isBlog: false,
            isHidden: true,
            isNewWindow: false,
            isBanner: false
          }
        },
        {
          path: '/invest',
          name: 'Invest',
          component: Invest,
          meta: {
            title: i18n.global.t("header.invest"),
            error: false,
            isBlog: false,
            isHidden: true,
            isNewWindow: false,
            isBanner: false
          }
        },
        {
          path: '/fund',
          name: 'Fund',
          component: Fund,
          meta: {
            title: i18n.global.t("header.fundPage"),
            error: false,
            isBlog: false,
            isHidden: true,
            isNewWindow: false,
            isBanner: false
          }
        },
        {
          path: '/contact',
          name: 'Contact',
          component: Contact,
          meta: {
            title: i18n.global.t("header.contact"),
            error: false,
            isBlog: false,
            isNewWindow: false,
            isBanner: false
          },
        },
        {
          path: '/help',
          name: 'Help',
          meta: {
            title: i18n.global.t("header.help"),
            error: false,
            isBlog: false,
            isNewWindow: true,
            isBanner: false
          },
        },
      ]
    },
    {
      path: '/about',
      name: 'AboutPageRoot',
      component: About,
      meta: {
        title: i18n.global.t("header.about"),
        error: false,
        isBlog: false,
        isNewWindow: false,
        isBanner: false
      },
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: NotFound,
      meta: {
        error: true,
        title: i18n.global.t("header.notFound"),
      },
    },
  ]
})


router.beforeEach((to, from, next) => {
  if(to.meta.error) {
    next("/")
  }
  if (to.name === 'HomePage' || to.name === 'Help') {
    next("/")
  } else {
    next()
  }
  document.title = to.meta.title || i18n.global.t("companyName");
});



export default router
